<template>
  <div id="app">
    <div class="filenav">批量上传考生资料</div>
    <div class="own_contain">
      <div class="boxup">上传考生名单 <span style="color:red">*</span></div>
      <div class="filetext2" style="margin:-10px 0 10px -2px">（只能上传相同等级的考生信息）</div>
      <div class="boxdown">
         <a href="https://res.qxueyou.com/考生导入模板.xlsx">下载模板</a>
      </div>
      <q-upload-file
        title="考生名单"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
        @getFileDetail="getStudentDetail"
      >
      </q-upload-file>

      <div class="filetext">上传考生毕业证书 <span style="color:red">*</span></div>
      <div class="filetext2">
        (ZIP格式：压缩包中每个文件格式为扫描件PDF,小于1M,以身份证号命名。例：440000********.pdf)
      </div>
      <div class="file_flex">
        <q-upload-file
          title="毕业证书"
          accept="application/x-zip-compressed"
          @getFileDetail="getGraduateDetail"
        >
        </q-upload-file>
        <file-box-example
          headert="示例"
          imgName="certificate"
        ></file-box-example>
      </div>
      

      <div class="filetext">上传考生社保记录</div>
      <div class="filetext2">
        (ZIP格式：压缩包中每个文件格式为扫描件PDF,小于1M,以身份证号命名。例：440000********.pdf)
      </div>

      <div class="file_flex">
        <q-upload-file
          title="社保记录"
          accept="application/x-zip-compressed"
          @getFileDetail="getSocialDetail"
        >
        </q-upload-file>
        <file-box-example
          headert="示例"
          imgName="social"
        ></file-box-example>
      </div>

      <div class="filetext">上传工作经验及证明文件 <span style="color:red">*</span></div>
      <div class="filetext2">
        (ZIP格式：压缩包中每个文件格式为扫描件PDF，小于1M，以身份证号命名。例：440000********.pdf)
      </div>

      <div class="file_flex">
        <q-upload-file
          title="工作经验及证明文件"
          accept="application/x-zip-compressed"
          @getFileDetail="getWorkExperienceDetail"
        >
        </q-upload-file>
        <file-box-example
          headert="示例"
          imgName="experience"
        ></file-box-example>
      </div>

      <div class="filetext">上传考生身份证（正反面）<span style="color:red">*</span></div>
      <div class="filetext2">
        (ZIP格式：压缩包中每个文件格式为扫描件PDF,扫描在一张A4纸上,小于1M,以身份证号命名。例：440000********.pdf)
      </div>

      <div class="file_flex">
        <q-upload-file
          title="身份证（正反面）"
          accept="application/x-zip-compressed"
          @getFileDetail="getIDCardDetail"
        >
        </q-upload-file>
        <file-box-example
          headert="示例"
          imgName="idCard"
        ></file-box-example>
      </div>

      <div class="filetext">上传考生证件照 <span style="color:red">*</span></div>
      <div class="filetext2">
        (ZIP格式：压缩包中每个文件格式为扫描件jpg,小于200k,2寸白底照:3.5cm*5.3cm,像素306*378,以身份证号命名。例：440000********.jpg)
      </div>

      <div class="file_flex">
        <q-upload-file
          title="证件照"
          accept="application/x-zip-compressed"
          @getFileDetail="getIDPhotoDetail"
        >
        </q-upload-file>
        <file-box-example
          headert="示例"
          imgName="personCard"
        ></file-box-example>
      </div>
      
      <div class="filetext">上传考生报名申报表 <span style="color:red">*</span></div>
      <div class="filetext2">
        (ZIP格式：压缩包中每个文件格式为扫描件PDF,小于1M,以身份证号命名。例：440000********.pdf)
      </div>

      <div class="file_flex">
        <q-upload-file
          title="报名申报表"
          accept="application/x-zip-compressed"
          @getFileDetail="getDeclarationDetail"
        >
        </q-upload-file>
        <file-box-example
          headert="示例"
          imgName="declare"
        ></file-box-example>
      </div>


      <div class="filetext">上传考生学信网验证报告 <span style="color:red">*</span></div>
      <div class="filetext2">
        (ZIP格式：压缩包中每个文件格式为扫描件PDF,小于1M,以身份证号命名。例：440000********.pdf)
      </div>

      <div class="file_flex">
        <q-upload-file
          title="学信网验证报告"
          accept="application/x-zip-compressed"
          @getFileDetail="getXueXinDetail"
        >
        </q-upload-file>
        <file-box-example
          headert="示例"
          imgName="xuexin"
        ></file-box-example>
      </div>
      
      <div class="filetext">上传职业技能/职业资格/职称证书</div>
      <div class="filetext2">
        (ZIP格式：压缩包中每个文件格式为扫描件PDF,小于1M,以身份证号命名。例：440000********.pdf)
      </div>

      <div class="file_flex">
        <q-upload-file
          title="证书"
          accept="application/x-zip-compressed"
          @getFileDetail="getGraduationCertificateDetail"
        >
        </q-upload-file>
        <file-box-example
          headert="示例"
          imgName="graduate"
        ></file-box-example>
      </div>
      

      <button class="own_next" @click="submitSignup">提交报名</button>
    </div>

    <!-- 提交提示 -->
    <van-dialog v-model="importDialog" :title="importFlag?'':'提示'" confirmButtonColor="#54B0FB" :show-confirm-button="false">
      <div class="import_success" v-if="importFlag">
        <van-image
          width="100"
          height="100"
          :src="require('@/assets/succees.png')"
        />
        <p class="msg">成功提交 <span style="font-size:32px;color:#54B0FB">{{importCount}}</span> 位考生信息！</p>
        <span class="tip">需在「批量约考」中查看考生信息并进行二次确认</span>
      </div>
      <div class="import_failed" v-else> 
        <span>{{importTip}}</span>
      </div>
      <van-divider></van-divider>
      <div class="import_confirm">
        <span @click="confirm">确定</span>
      </div>
    </van-dialog>
    <q-tips></q-tips>
  </div>
</template>

<script>
import ArticleItem from "@/components/article-item/index.vue";
import fileBox from "@/components/filebox.vue";
import headerBox from "@/components/header.vue";
import fileBoxExample from '@/view/reserve/fileUploadExample.vue'
import QUploadFile from '@/components/uploadFile.vue'
import QTips from '@/view/organization/uploadList/compoment/tip.vue'
export default {
  components: {
    ArticleItem,
    fileBox,
    headerBox,
    fileBoxExample,
    QUploadFile,
    QTips
  },
  data() {
    return {
      studentDetail: {}, //上传的文件信息
      graduateDetail: {},
      socialDetail: {},
      workExperience: {},
      IDCardDetail: {},
      IDPhotoDetail: {},
      declarationDetail: {},
      xueXinDetail: {},
      graduationCertificate:{},
      importDialog: false, //提交后弹窗
      importFlag: false,  //提交成功或失败
      importTip: '',
      importCount: 0,
      submitFlag: false //是否正在提交中
    }
  },
  methods: {
    getStudentDetail: function(value) {
      this.studentDetail = value
      console.log("考生名单", value)
    },
    getGraduateDetail: function(value) {
      this.graduateDetail = value
      console.log("毕业证书扫描件", value)
    },
    getSocialDetail: function(value) {
      this.socialDetail = value
      console.log("社保记录", value)
    },
    getWorkExperienceDetail: function(value) {
      this.workExperience = value
      console.log("工作经验", value)
    },
    getIDCardDetail: function(value) {
      this.IDCardDetail = value
      console.log("身份证", value)
    },
    getIDPhotoDetail: function(value) {
      this.IDPhotoDetail = value
      console.log("证件照", value)
    },
    getDeclarationDetail: function(value) {
      this.declarationDetail = value
      console.log("报名申报表", value)
    },
    getXueXinDetail: function(value) {
      this.xueXinDetail = value
      console.log("学信网", value)
    },
    getGraduationCertificateDetail: function(value){
      this.graduationCertificate = value
    },
    submitSignup() {  //提交数据
			let params = {
				filePath: this.studentDetail.uploadPath,
				certificateUrl: this.graduateDetail.uploadPath,
        workUrl: this.workExperience.uploadPath,
				identityUrl: this.IDCardDetail.uploadPath,
				PhotoUrl: this.IDPhotoDetail.uploadPath,
        declareUrl: this.declarationDetail.uploadPath,
        networkUrl: this.xueXinDetail.uploadPath,
			}
      console.log(params);
			if (!Object.keys(params).every(key => params[key])) {
				this.$message({
					message: '请上传文件',
					type: 'warning'
				})
				return
			}
      params.securityUrl = this.socialDetail.uploadPath
      params.completionCertificate = this.graduationCertificate.uploadPath
      const loading = this.$loading({
        lock: true,
        text: '提交数据中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$http.post('/examFile/import/getImport', params).then(res => {
        if(res.data.success){
          this.importFlag = true
          this.importCount = res.data.data.successCount
        }else{
          this.importFlag = false
          this.importTip = res.data.msg
        }
        this.importDialog = true
      }).catch(() => {
        this.$message({
          message: '提交失败',
          type: 'warning'
        })
      }).finally(()=> {
        loading.close()
      })
    },
    confirm() {  //提交成功
      if(this.importFlag){
        this.importDialog = false
        this.$router.push('/batchSignUp')
      }else{
        this.importDialog = false
      }
    }
  },
};
</script>

<style lang="less" scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 30px;
  width: 100%;
  height: 100vh;
  overflow: auto;
}
::-webkit-scrollbar {
  display: none; 
}
.filenav {
  font-size: 32px;
  font-weight: 600;
  height: @minboxgao;
  padding: 0 @padingbox;
  line-height: @minboxgao;
  background: @boxback;
}
.own_contain {
  width: 100%;
  background: @whitee;
  margin: auto;
  box-sizing: border-box;
  padding: 0 @padingbox;
  overflow: auto;
  .boxup {
    margin: @padingbox 0;
  }
  .boxdown {
    color: @bluebtn;
    padding-bottom: @checkringht;
  }
}
.select_container {
  position: relative;
  width: 100%;
  border: 1px solid @tableborder;
}
.select_container .select_r {
  position: absolute;
  right: 4px;
}
.fileboxheader {
  width: 500px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px solid #54b0fb;
  background: #54b0fb;
}

.fileboxmain {
  background: #a1a6a8;
  width: 500px;
  height: 250px;
  border: 1px solid #54b0fb;
  display: flex;
  justify-content: center;
  align-items: center;
}
.fileboxbox {
  text-align: center;
}
.fileboxtext {
  color: #54b0fb;
}
.own_test_out {
  position: relative;
}
.gettest {
  position: absolute;
  right: 5px;
}
.own_next {
  margin-top: @padingboxmax;
  color: white;
  background: #54b0fb;
  border: 0;
  border-radius: @circlemin;
  width: 100%;
  height: @minboxgao;
  margin-bottom: 30px;
  cursor: pointer;
}
.writenamebox {
  width: 450px;
  height: 450px;
  background: #a1a6a8;
}
#top {
  text-align: center;
  height: 176px;
  box-sizing: border-box;
  padding-top: 125px;
  background-color: @backgroundcolor;
  padding-bottom: 69px;
}
.filetext {
  margin-top: @textgao;
  // .fileicon{
  // 	color: @bluebtn;
  // }
}
.filetext2 {
  margin: 10px;
  color: @graycolor;
  font-size: 14PX;
}
a {
  color: @bluebtn;
  text-decoration: none;
}
.import_failed{
  padding: 50px;
}
.import_success {
  padding: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .msg{
    font-size: 36px;
    font-weight: 500;
    margin: 20px 0;
  }
  .tip{
    font-size: 26px;
    line-height: 44px;
    color: #666666;
    text-align: center;
  }
}
.import_confirm{
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2196F3;
  padding-bottom: 16PX;
  span{
    font-size: 18PX;
    cursor: pointer;
  }
}
.file_flex {
  display: flex;
  justify-content: space-between;
}
</style>
